<div class="emd-hier-grid-wrap">
  <ag-grid-angular
    class="ag-theme-alpine emd-hier-grid arrow"
    [style.height.px]="effectiveHeight"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [rowData]="rowData"
    [rowHeight]="rowHeight"
    [animateRows]="true"
    [masterDetail]="true"
    [detailRowAutoHeight]="true"
    [detailCellRenderer]="'agDetailCellRenderer'"
    [detailCellRendererParams]="detailCellRendererParams"
    [suppressAggFuncInHeader]="true"
    [suppressContextMenu]="true"
    [rowClassRules]="rowClassRules"
    [pinnedBottomRowData]="grandTotal ? [grandTotalRow] : undefined"
    (gridReady)="onGridReady($event)"
    (rowClicked)="onRowClicked($event)"
  ></ag-grid-angular>

  <div class="emd-grid-empty" *ngIf="!rowData.length">
    There is no data for the selected filters
  </div>
</div>
